module.exports = __webpack_public_path__ + "static/img/5.9285a29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/5.png
// module id = IwrI
// module chunks = 0